import { render, staticRenderFns } from "./TractBids.vue?vue&type=template&id=57acf964&"
import script from "./TractBids.vue?vue&type=script&lang=js&"
export * from "./TractBids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports